import { FileTextIcon } from 'lucide-react';

export const TransactionIcon = FileTextIcon;
export default TransactionIcon;
